
import { useEffect, useState } from 'react';
import PowerSmiliesPawnsSection from '@/components/help-center/powers/PowerSmiliesPawnsSection';
import { usePowersCms } from '@/components/painel/powers/powers-cms-context';
import { resolvePowerForPublicDetail, type PowerInfo } from '@/lib/powers-data';

type AcePawnsSectionProps = {
  slug: string;
};

/** Galeria de peões do Ace — mesma secção visual que `/powers/[slug]`. */
export function AcePawnsSection({ slug }: AcePawnsSectionProps) {
  const { getPowerBySlug: getCmsPower, hydrated: cmsHydrated } = usePowersCms();
  const [power, setPower] = useState<PowerInfo | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const resolved = await resolvePowerForPublicDetail(slug, {
        cmsHydrated,
        getCmsPower,
      });

      if (cancelled) return;
      setPower(resolved);
      setReady(true);
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [slug, cmsHydrated, getCmsPower]);

  if (!ready || !power) return null;

  return <PowerSmiliesPawnsSection power={power} productKind="ace" />;
}
